// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c36fb367f6689a1d79639eaff146ee6ea00c534e.chunk.bundle.js";
};